<template>
  <CRow>
    <CCol>
      <CCard>
        <CCardHeader>Create New Event & Tips Action</CCardHeader>
        <CCardBody>
          <CRow class="form-group">
            <CCol :col="8">
              <CInput
                  v-model="corporateActionData.corporate_action_title"
                  label="Title"
                  class="mb-0"
                  type="text"
                  required
                  horizontal
                  placeholder="Title"
                  :is-valid="corporateActionData.corporate_action_title.length > 65 ? false : null"
                  invalid-feedback="Title more than 65 characters"
                  @change="handleCorporateActionTitle"
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="8">
              <CInput
                  v-model="corporateActionData.corporate_action_slug"
                  id="corporate_slug"
                  label="Url Name"
                  class="mb-0"
                  type="text"
                  required
                  horizontal
                  placeholder="Url Name"
                  @change="handleCorporateActionSlug"
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="8">
              <CInput
                  label="Meta Description"
                  class="mb-0"
                  type="text"
                  required
                  horizontal
                  placeholder="Meta Description"
                  @change="handleMetaDescription"
              />
            </CCol>
          </CRow>

          <CRow class="form-group">
            <CCol :col="8">
              <CInput
                  label="Meta Keyword"
                  class="mb-0"
                  type="text"
                  required
                  horizontal
                  placeholder="Meta Keyword"
                  @change="handleMetaKeyword"
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="8">
              <CSelect
                  label="Jenis Article"
                  :options="options"
                  required
                  horizontal
                  placeholder="Pilih"
                  @change="handleCorporateActionType"
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="8">
              <CSelect
                label="Bahasa"
                :options="optionsLanguage"
                required
                horizontal
                placeholder="Pilih"
                v-model="corporateActionData.language"
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="8">
              <div role="group" class="form-group form-row">
                <label class="col-form-label col-sm-3">Author</label>
                <div class="col-sm-9" style="z-index: 2;">
                  <multiselect
                      horizontal
                      v-model="author"
                      :options="optionsAuthor"
                      label="author_name"
                      track-by="author_name"
                      placeholder="Select author"
                      :multiple="false"
                      @change="handleAuthor"
                  >
                  </multiselect>
                </div>
              </div>
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="8">
              <CInput
                  label="Active Date"
                  class="mb-0"
                  type="datetime-local"
                  required
                  horizontal
                  placeholder="Active Date"
                  v-model="corporateActionData.active_date"
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="12">
              <a>Content</a>
              <editor
                  id="editor"
                  :api-key="key"
                  :init="initOption"
                  v-model="corporateActionData.corporate_action_content"
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="8">
              <CInputFile
                  label="File Illustration"
                  horizontal
                  type="file"
                  :isValid="false"
                  :invalidFeedback="error.attachment_corporate_action_photo_url.message"
                  @change="handleCorporateActionPhotoUrl"
              >
                <template v-slot:label-after-input>
                  File size should be below 250KB and Optimize picture size is 980px x 400px.
                </template>
              </CInputFile>
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="8">
              <img class="image-ilustrasi" id="myImg" v-if="url" :src="url"/>
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="8">
              <CInput
                  label="ALT Illustration"
                  class="mb-0"
                  type="text"
                  horizontal
                  placeholder="ALT Illustration"
                  v-model="corporateActionData.alt_photo"
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="8">
              <CInputFile
                  label="File Sub Illustration"
                  horizontal
                  type="file"
                  :isValid="false"
                  :invalidFeedback="error.attachment_corporate_action_sub_photo_url.message"
                  @change="handleCorporateActionSubPhotoUrl"
              >
                <template v-slot:label-after-input>
                  File size should be below 150KB and Optimize picture size is 300px x 200px.
                </template>
              </CInputFile>
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="8">
              <img class="image-ilustrasi" id="myImg" v-if="subPhotoUrl" :src="subPhotoUrl"/>
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="8">
              <CInput
                  label="ALT Sub Illustration"
                  class="mb-0"
                  type="text"
                  horizontal
                  placeholder="ALT Sub Illustration"
                  v-model="corporateActionData.alt_sub_photo"
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="8">
              <div role="group" class="form-group form-row">
                <label class="col-form-label col-sm-3">Hashtag</label>
                <div class="col-sm-9">
                  <multiselect
                      horizontal
                      v-model="corporateActionData.corporate_action_hashtag_ids"
                      :options="optionsHashtag"
                      :multiple="true"
                      @change="handleHashtagCorporateAction">
                  </multiselect>
                </div>
              </div>
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="8">
              <div role="group" class="form-group form-row">
                <label class="col-form-label col-sm-3">Category</label>
                <div class="col-sm-9">
                  <multiselect
                      horizontal
                      :value="selectedArticleCategories"
                      :options="optionsArticleCategories"
                      label="name"
                      track-by="id"
                      :multiple="true"
                      @input="handleArticleCategoriesChange"
                  >
                  </multiselect>
                </div>
              </div>
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="8">
              <CSelect
                  label="Show in related Event & Tips?"
                  :options="optionsShowRelated"
                  required
                  horizontal
                  v-model="corporateActionData.corporate_action_related_show_option"
                  @change="handleShowRelatedCorporateAction"
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="8">
              <CSelect
                  label="Article Info"
                  :options="optionsArticleInfo"
                  required
                  horizontal
                  v-model="corporateActionData.article_info"
                  @change="handleShowArticleInfo"
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="8">
              <CSelect
                  label="Suggestion Article"
                  :options="optionsSuggestionArticle"
                  required
                  horizontal
                  v-model="corporateActionData.is_suggested"
                  @change="handleShowIsSuggested"
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="8">
              <CInput
                  v-if="this.visiblePriority"
                  id="corporate_priority"
                  type="number"
                  min="0"
                  max="1000"
                  label="Priority"
                  class="mb-0"
                  horizontal
                  placeholder="Priority to show on Website"
                  v-model="corporateActionData.priority"
              />
            </CCol>
          </CRow>
          <CRow class="form-group" v-if="accountGroup !== 'EXTERNAL'">
            <CCol :col="8">
              <CSelect
                  label="Status"
                  :options="optionsStatus"
                  required
                  horizontal
                  v-model="corporateActionData.status"
                  @change="handleStatusCorporateAction"
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="8">
              <CSelect
                  label="Show Section POS Interpack"
                  :options="optionsShowSectionPOSInterpack"
                  required
                  horizontal
                  v-model="corporateActionData.show_pos_interpack"
                  @change="handleShowSectionPOSInterpack"
              />
            </CCol>
          </CRow>
          <CRow class="form-group" v-if="corporateActionData.article_info === 'NEWS'">
            <CCol :col="8">
              <CSelect
                  label="Category"
                  :options="optionsCategory"
                  v-model="corporateActionData.corporate_action_category_id"
                  horizontal
                  :required="corporateActionData.article_info === 'NEWS'"
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="8">
              <CSelect
                  label="FAQ Status"
                  :options="optionsFaqStatus"
                  required
                  horizontal
                  v-model="corporateActionData.faq_status"
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="12">
              <div class="mb-2">
                <strong>FAQ</strong>
              </div>
              <DynamicCrudTable
                  title=""
                  v-model="faqs"
                  :columns="faqColumns"
                  :max-rows="6"
              />
            </CCol>
          </CRow>
          <CRow>
            <CCol :col="8">
              <div role="group" class="form-group form-row">
                <label class="col-form-label col-sm-3">Like & Comment</label>
                <div class="col-sm-9">
                  <multiselect
                    v-model="likeCommentSelection"
                    :options="optionsLikeComment"
                    :multiple="true"
                  >
                  </multiselect>
                </div>
              </div>
            </CCol>
          </CRow>
        </CCardBody>
        <CCardFooter>
          <CRow>
            <CCol sm="5">
              <CButton color="primary" @click="goBack">Back</CButton>
            </CCol>
            <CCol sm="7" class="d-none d-md-block">
              <CButton
                color="success"
                class="float-right"
                :disabled="isSubmitting"
                @click="createNewProgram"
              >{{ isSubmitting ? "Saving..." : "Save" }}</CButton>
            </CCol>
          </CRow>
        </CCardFooter>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
// import usersData from './UsersData'
import axios from "axios";
import Swal from "sweetalert2";
import moment from "moment"
import jwt from "jsonwebtoken"
import Editor from "@tinymce/tinymce-vue";
import Multiselect from 'vue-multiselect'
import {validateImageHeightAndWidth} from "./helper";
import initTinymce from "@/app/constants/initTinymce";
import DynamicCrudTable from "@/components/DynamicCrudTable.vue";

export default {
  name: "ProgramCreate",
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.usersOpened = from.fullPath.includes("usercreate");
    });
  },
  components: {
    editor: Editor,
    Multiselect,
    DynamicCrudTable
  },
  data() {
    return {
      corporateActionData: {
        corporate_action_title: "",
        corporate_action_slug: "",
        corporate_action_content: "",
        active_date: "",
        attachment_program_photo_url: null,
        corporate_action_hashtag_ids: "",
        corporate_action_related_show_option: "YES",
        is_suggested: "YES",
        article_info: "MITRA",
        status: "ACTIVE",
        meta_info_description: "",
        meta_info_keyword: "",
        show_pos_interpack: false,
        corporate_action_category_id: 4,
        priority: "",
        language: "indonesia",
        faq_status: "ACTIVE",
      },
      faqs: [],
      faqColumns: [
        { key: "priority", label: "Priority", type: "number" },
        { key: "question", label: "Question", type: "text", maxlength: 255 },
        { key: "answer", label: "Answer", type: "textarea" }
      ],
      optionsFaqStatus: [
        { label: "ACTIVE", value: "ACTIVE" },
        { label: "INACTIVE", value: "INACTIVE" }
      ],
      author: null,
      programType: "",
      domain: process.env.VUE_APP_DOMAIN_URL,
      token: "Bearer " + localStorage.getItem("token"),
      optionsAuthor: [],
      options: ["Event", "Tips"],
      optionsStatus: ["ACTIVE", "INACTIVE"],
      optionsShowSectionPOSInterpack: [{value: true, label: "ACTIVE"}, {value: false, label: "INACTIVE"}],
      optionsHashtag: [],
      optionsArticleCategories: [],
      selectedArticleCategories: [],
      optionsCategory: [],
      optionsShowRelated: ["YES", "NO", "ALWAYS SHOW"],
      optionsArticleInfo: [
        { label: "MITRA", value: "MITRA" },
        { label: "SELLER", value: "SELLER" },
        { label: "BLOG MALAYSIA", value: "BLOG_MALAYSIA" },
        { label: "NEWS", value: "NEWS" }
      ],
      optionsSuggestionArticle: ["YES", "NO"],
      optionsLanguage: [
        { label: "Indonesia", value: "indonesia" },
        { label: "English", value: "english" }
      ],
      optionsLikeComment: ["Like", "Comment"],
      likeCommentSelection: [],
      url: null,
      alt_photo: "",
      subPhotoUrl: null,
      alt_sub_photo: "",
      initOption: initTinymce.init,
      key: initTinymce.key,
      error: {
        attachment_corporate_action_photo_url: {
          message: ''
        },
        attachment_corporate_action_sub_photo_url: {
          message: ''
        }
      },

      visiblePriority: false,
      accountGroup: null,
      isSubmitting: false,
    };
  },
  mounted() {
    this.authentication();
    this.getAuthor(this.corporateActionData.language);
    this.getHashtagList();
    this.getArticleCategoryList();
    this.getCategoryList();
    this.visiblePriority =
        this.corporateActionData.is_suggested === "YES" && this.corporateActionData.article_info !== "NEWS";
  },
  watch: {
    'corporateActionData.language'(newVal, oldVal) {
      if (typeof newVal === 'string' && newVal && newVal !== oldVal) {
        if (oldVal) {
          this.author = null;
        }
        this.getAuthor(newVal);
      }
    }
  },
  computed: {},
  methods: {
    getCategoryList() {
      axios.get(`${this.domain}/v2/event_and_tips/news/category`, {
        headers: {
          Authorization: this.token,
          "Content-Type": "application/json",
        },
      })
          .then((response) => {
            this.optionsCategory = response.data.map(item => ({
              value: item.id,
              label: item.name
            }))
          })
          .catch((err) => {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: err.response?.data?.desc?.id || err.message
            });
          });
    },
    authentication() {
      const data = jwt.decode(localStorage.getItem("token"));
      this.accountGroup = data.account_group;

      if (this.accountGroup === "EXTERNAL") {
        this.corporateActionData.status = "INACTIVE";
      }

      if (
          data.account_group === "MARKETING" ||
          data.account_group === "ADMIN" ||
          data.account_group === "ADMINISTRATOR" ||
          data.account_group === "EXTERNAL"
      ) {
        return null
      } else {
        this.$router.push({path: `/`});
      }
    },
    getAuthor(language) {
      let lang = typeof language === 'string' ? language : this.corporateActionData?.language;
      if (typeof lang !== 'string' || !lang) {
        lang = "indonesia";
      }
      axios.get(`${this.domain}/v2/authors/data?page=1&per_page=100&language=${lang}`, {
        headers: {
          Authorization: this.token,
          "Content-Type": "application/json",
        },
      })
          .then((response) => {
            // JSON responses are automatically parsed.
            const authorsData = (response.data && response.data.data && response.data.data.data) || [];
            this.optionsAuthor = authorsData.map(element => ({
              author_id: element.author_id,
              author_name: element.author_name
            }));
          })
          .catch((err) => {
            if (err.response?.data?.message === "record not found" || err.response?.data?.desc?.id === "record not found") {
              this.optionsAuthor = [];
              return;
            }
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: err.response?.data?.desc?.id || err.message
            });
          });
    },
    getHashtagList() {
      axios
          .get(`${this.domain}/v1/corporate_action_hashtag/data`, {
            params: {
              per_page: 10000,
              status: "ACTIVE"
            },
            headers: {
              Authorization: this.token,
              "Content-Type": "application/json",
            },
          })
          .then((response) => {
            // JSON responses are automatically parsed.
            let data = [];
            const hashtagData = response.data.data.filter(element => {
              return element.status == 'ACTIVE'
            })
            hashtagData.forEach(element => {
              data.push(
                  element.corporate_action_hashtag_title,
              )
            });
            this.optionsHashtag = data
          })
          .catch((err) => {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: err.response.data.desc.id
            });
          });
    },
    getArticleCategoryList() {
      axios
          .get(`${this.domain}/v1/corporate_action_category/data`, {
            params: {
              status: "ACTIVE",
              per_page: 10000
            },
            headers: {
              Authorization: this.token,
              "Content-Type": "application/json",
            },
          })
          .then((response) => {
            const categories = response && response.data && Array.isArray(response.data.data)
                ? response.data.data
                : [];
            this.optionsArticleCategories = categories.map(category => ({
              id: category.id,
              name: category.name
            }));

            this.selectedArticleCategories = [];
          })
          .catch((err) => {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: err.response?.data?.message?.id || err.message
            });
          });
    },
    goBack() {
      this.usersOpened
          ? this.$router.go(-1)
          : this.$router.push({path: "/management/corporate"});
    },
    handleCorporateActionTitle(event) {
      var slug = event.replaceAll(/[^A-Za-z0-9 ]/g, '').replaceAll(' ', '-').replaceAll('--', '-').toLowerCase().trim();
      document.getElementById('corporate_slug').value = slug;
      this.corporateActionData.corporate_action_slug = slug;
      this.corporateActionData.corporate_action_title = event;
    },
    handleCorporateActionSlug(event) {
      var slug = event.replaceAll(/[^A-Za-z0-9 ]/g, '').replaceAll(' ', '-').replaceAll('--', '-').toLowerCase().trim();
      document.getElementById('corporate_slug').value = slug;
      this.corporateActionData.corporate_action_slug = slug;
    },
    handleCorporateActionType(event) {
      this.corporateActionData.corporate_action_type = event.target.value;
    },
    handleAuthor(event) {
      this.author = event;
    },
    handleCorporateActionContent(event) {
      this.corporateActionData.corporate_action_content = event;
    },
    handleStatusCorporateAction(event) {
      this.corporateActionData.status = event.target.value;
    },
    handleShowSectionPOSInterpack(event) {
      this.corporateActionData.show_pos_interpack = event.target.value;
    },
    async handleCorporateActionPhotoUrl(event) {
      const file = event[0];
      const {dataUrl, err} = await validateImageHeightAndWidth(file)
      this.url = dataUrl
      this.error.attachment_corporate_action_photo_url.message = err
      this.corporateActionData.attachment_corporate_action_photo_url = event[0];
    },
    async handleCorporateActionSubPhotoUrl(event) {
      const file = event[0];
      const {dataUrl, err} = await validateImageHeightAndWidth(file, true)
      this.subPhotoUrl = dataUrl
      this.error.attachment_corporate_action_sub_photo_url.message = err
      this.corporateActionData.attachment_corporate_action_sub_photo_url = event[0];
    },
    handleShowRelatedCorporateAction(event) {
      this.corporateActionData.corporate_action_related_show_option = event.target.value;
    },
    handleShowArticleInfo(event) {
      const value = event.target.value;
      this.corporateActionData.article_info = value;
      this.visiblePriority =
          this.corporateActionData.is_suggested === "YES" && value !== "NEWS";
    },
    handleShowIsSuggested(event) {
      const value = event.target.value;
      this.corporateActionData.is_suggested = value;
      this.visiblePriority =
          value === "YES" && this.corporateActionData.article_info !== "NEWS";
    },
    handleHashtagCorporateAction(event) {
      this.corporateActionData.corporate_action_hashtag_ids = event.target.value;
    },
    handleArticleCategoriesChange(categories) {
      const selectedCategories = Array.isArray(categories) ? categories : [];
      const currentCategories = Array.isArray(this.selectedArticleCategories)
          ? this.selectedArticleCategories
          : [];
      const semuaCategory = this.optionsArticleCategories.find(category => category.name === "Semua");

      if (!semuaCategory) {
        this.selectedArticleCategories = selectedCategories;
        return;
      }

      const isSemuaCategory = category =>
          category && String(category.id) === String(semuaCategory.id);
      const addedSemuaCategory =
          selectedCategories.some(isSemuaCategory) && !currentCategories.some(isSemuaCategory);
      const addedSpecificCategory = selectedCategories.some(category =>
          category &&
          !isSemuaCategory(category) &&
          !currentCategories.some(currentCategory =>
              currentCategory && String(currentCategory.id) === String(category.id)
          )
      );

      if (addedSemuaCategory) {
        this.selectedArticleCategories = [semuaCategory];
      } else if (addedSpecificCategory) {
        this.selectedArticleCategories = selectedCategories.filter(category => !isSemuaCategory(category));
      } else {
        this.selectedArticleCategories = selectedCategories;
      }
    },
    handleCorporateActionStatus(event) {
      this.corporateActionData.status = event.target.value;
    },
    handleMetaDescription(event) {
      this.corporateActionData.meta_info_description = event;
    },
    handleMetaKeyword(event) {
      this.corporateActionData.meta_info_keyword = event;
    },
    handleCorporateActionLanguage(event) {
      const value = typeof event === 'string' ? event : (event && event.target ? event.target.value : null);
      if (typeof value === 'string' && value) {
        this.corporateActionData.language = value;
      }
    },
    createNewProgram() {
      if (this.isSubmitting) {
        return;
      }

      const semuaCategory = this.optionsArticleCategories.find(category => category.name === "Semua");
      if (
          !semuaCategory ||
          semuaCategory.id === undefined ||
          semuaCategory.id === null ||
          semuaCategory.id === ""
      ) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Category Semua tidak dapat diubah"
        });
        return;
      }

      const selectedArticleCategories = Array.isArray(this.selectedArticleCategories)
          ? this.selectedArticleCategories
          : [];
      const articleCategoryIDs = selectedArticleCategories
          .filter(category => category && category.id !== undefined && category.id !== null && category.id !== "")
          .map(category => category.id);

      if (
          this.corporateActionData.attachment_corporate_action_photo_url &&
          this.corporateActionData.attachment_corporate_action_sub_photo_url
      ) {
        if (this.corporateActionData.attachment_corporate_action_photo_url['size'] > 250000) {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Picture too big. Please upload below 250 KB"
          });
          return;
        }
        if (this.error.attachment_corporate_action_photo_url.message) {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: this.error.attachment_corporate_action_photo_url.message
          });
          return;
        }
        if (this.corporateActionData.attachment_corporate_action_sub_photo_url['size'] > 150000) {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Picture too big. Please upload below 150 KB"
          });
          return;
        }
        if (this.error.attachment_corporate_action_sub_photo_url.message) {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: this.error.attachment_corporate_action_sub_photo_url.message
          });
          return;
        }
      } else {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Picture harap diisi."
        });
        return;
      }

      if (this.corporateActionData.is_suggested === "YES" && this.corporateActionData.article_info !== "NEWS") {

        if (!this.corporateActionData.priority) {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Priority wajib diisi jika suggested."
          });
          return;
        }

        const p = Number(this.corporateActionData.priority);
        if (p < 1 || p > 5) {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Priority hanya boleh 1 sampai 5."
          });
          return;
        }
      }

      if (this.faqs && this.faqs.length > 6) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Maksimal 6 data FAQ."
        });
        return;
      }

      if (this.faqs && this.faqs.length > 0) {
        for (let i = 0; i < this.faqs.length; i++) {
          const item = this.faqs[i];
          const p = Number(item.priority);
          if (item.priority === "" || item.priority === null || isNaN(p) || p < 0) {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: `Priority FAQ ke-${i + 1} harus berupa angka non-negatif.`
            });
            return;
          }
          if (!item.question || !item.question.trim()) {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: `Pertanyaan FAQ ke-${i + 1} harus diisi.`
            });
            return;
          }
          if (item.question.trim().length > 255) {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: `Pertanyaan FAQ ke-${i + 1} maksimal 255 karakter.`
            });
            return;
          }
          if (!item.answer || !item.answer.trim()) {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: `Jawaban FAQ ke-${i + 1} harus diisi.`
            });
            return;
          }
        }
      }

      const activeDate = moment(
        this.corporateActionData.active_date,
        "YYYY-MM-DDTHH:mm"
      ).format("YYYY-MM-DDTHH:mm:ssZ");
      let formData = new FormData();
      formData.append("corporate_action_title", this.corporateActionData.corporate_action_title);
      formData.append("corporate_action_slug", this.corporateActionData.corporate_action_slug);
      formData.append("corporate_action_type", this.corporateActionData.corporate_action_type);
      formData.append("corporate_action_author", this.author ? this.author.author_name : "");
      formData.append("corporate_action_author_id", this.author ? this.author.author_id : "");
      formData.append("corporate_action_category_id", this.corporateActionData.corporate_action_category_id);
      formData.append("active_date", activeDate);
      if (this.corporateActionData.is_suggested === "YES" && this.corporateActionData.article_info !== "NEWS") {
        formData.append("priority",  this.corporateActionData.priority);
      }
      formData.append(
          "corporate_action_content",
          this.corporateActionData.corporate_action_content
      );
      if (this.corporateActionData.attachment_corporate_action_photo_url) {
        formData.append(
            "attachment_corporate_action_photo_url",
            this.corporateActionData.attachment_corporate_action_photo_url
        );
      }
      formData.append("alt_photo", this.corporateActionData.alt_photo);
      if (this.corporateActionData.attachment_corporate_action_sub_photo_url) {
        formData.append(
            "attachment_corporate_action_sub_photo_url",
            this.corporateActionData.attachment_corporate_action_sub_photo_url
        );
      }
      formData.append("alt_sub_photo", this.corporateActionData.alt_sub_photo);
      formData.append("status", this.corporateActionData.status);
      formData.append(
          "corporate_action_hashtag_ids",
          this.corporateActionData.corporate_action_hashtag_ids + ','
      );
      formData.append("corporate_action_article_category_ids", articleCategoryIDs.join(","));
      formData.append(
          "corporate_action_related_show_option",
          this.corporateActionData.corporate_action_related_show_option
      );
      formData.append("article_info", this.corporateActionData.article_info);
      formData.append("is_suggested", this.corporateActionData.is_suggested === "YES" ? true : false);
      formData.append('meta_info_keyword', this.corporateActionData.meta_info_keyword)
      formData.append('meta_info_description', this.corporateActionData.meta_info_description)
      formData.append("show_pos_interpack", this.corporateActionData.show_pos_interpack);
      formData.append("language", this.corporateActionData.language);
      formData.append("faq_status", this.corporateActionData.faq_status || "ACTIVE");
      if (this.faqs && this.faqs.length > 0) {
        this.faqs.forEach((item, i) => {
          formData.append(`faq_priority[${i}]`, item.priority);
          formData.append(`faq_question[${i}]`, item.question.trim());
          formData.append(`faq_answer[${i}]`, item.answer.trim());
        });
      }
      formData.append("like_enabled", this.likeCommentSelection.includes("Like") ? "true" : "false");
      formData.append("comment_enabled", this.likeCommentSelection.includes("Comment") ? "true" : "false");
      this.isSubmitting = true;
      axios
          .post(`${this.domain}/v2/event_and_tips/admin`, formData, {
            headers: {
              Authorization: this.token,
              "Content-Type": "application/json"
            }
          })
          .then(response => {
            // JSON responses are automatically parsed.
            Swal.fire({
              icon: "success",
              title: `Corporate Data Created`,
              showConfirmButton: false,
              timer: 2000
            });
            this.items = response.data.data;
            this.$router.push({path: `/management/corporate`});
          })
          .catch(err => {
            this.isSubmitting = false;
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text:
                err &&
                err.response &&
                err.response.data &&
                err.response.data.desc &&
                err.response.data.desc.id
                  ? err.response.data.desc.id
                  : "Terjadi kesalahan saat membuat data",
            });
          });
    },
    validator(val) {
      return val ? val.length >= 4 : false;
    },
  }
};
</script>

<style scoped>
@import "./Corporate.css";
</style>
